import React, { useEffect } from 'react';
import { flowSteps, recordFlowProgress } from '../utils/recordFlowProgress';

import { Card } from 'react-bootstrap';
import { Link } from 'react-router';
import { LoginCard } from '../ui';
import LoginLayout from '../ui/Layout/LoginLayout';

const AccountDeletedContainer = () => {
  useEffect(() => {
    const asyncRecordFlowProgress = async () => {
      await recordFlowProgress(flowSteps.ACCOUNT_DELETION_CONFIRMATION);
    };
    asyncRecordFlowProgress();
  }, []);

  return (
    <LoginLayout>
      <LoginCard>
        <Card.Title as="h1">Your account has been deleted.</Card.Title>
        <Card.Text>We&apos;ve successfully deleted your account.</Card.Text>
        <Card.Text>
          If you change your mind, you can{' '}
          <Link className="color-primary" to="/signup">
            create a new account
          </Link>{' '}
          anytime.
        </Card.Text>
      </LoginCard>
    </LoginLayout>
  );
};

export default AccountDeletedContainer;
